import { render, staticRenderFns } from "./TotalsLC.vue?vue&type=template&id=e6fc7f70&scoped=true"
import script from "./TotalsLC.vue?vue&type=script&lang=js"
export * from "./TotalsLC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fc7f70",
  null
  
)

export default component.exports